@if (projectId() !== undefined) {
  <app-step-dot-menu
    [projectId]="projectId()!"
    testId="step3-2-dot-menu-button"
    [preselectedRole]="ProjectRoleType.CONTRIBUTOR"
    [preselectedAccessiblePages]="[ProjectStepType.RFQ_PROPOSAL_PARAMETER]"
  ></app-step-dot-menu>
}

<p-card class="mt-5">
  <app-card-title key="project.steps.proposalParameters" />

  @if (!stepPrerequisiteCompleted()) {
    <app-previous-step-incomplete-notice />
  } @else {
    @if (isLoadingState() || contractParametersResource.isLoading()) {
      <app-loading />
    } @else {
      <app-proposal-parameter-panels
        [projectId]="projectId()!"
        [contractParametersContainer]="contractParametersContainer()"
        [isReadOnly]="isReadOnly() || isCurrentStepLocked()"
        (saved)="onSaved()"
      />
    }
  }
</p-card>
